import "../css/Filter.css";
import NotifResponse from "../model/response/NotifResponse";
import NotifRequest from "../model/request/NotifRequest";
import "bootstrap-icons/font/bootstrap-icons.css";
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import default_avatar from '../images/default_avatar.png';



function Notification({ show, onClose }) {

  const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;
  const token = localStorage.getItem('token');

  const savedImage = localStorage.getItem("image");

  const navigation = useNavigate()

  const [notifications, setNotifications] = useState([]);

  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  useEffect(() => {
    if (show && loginVal) {

      getNotifAPIcall();
    }
  }, [show]);
  if (!show) return null;


  function getNotifAPIcall(userId) {

    console.log("Response:", "response.data");
    axios.get(
      ApiConfig.getUrl("User/getNotification"),
      {
        params: {
          userId: loginVal.user_Id
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then(response => {
        const api = ApiResponse.fromJson(response.data);
        // console.log("Notification Count:", api.response?.length);
        //  console.table(api.response); 
        console.log("Response:", api.statusCode);

        if (api.statusCode == 200) {
          setNotifications(api.response || []);


        }
        else {
          showToastFailed(api.errorMessage);
        }

      })
      .catch(error => {
        showToastFailed(error);
        console.error("Error:", error);
      });
  }

  const disableRightClick = (e) => {
    e.preventDefault();
  };
  return (
    <>

      <div className="notif-container mt-5" onContextMenu={disableRightClick}>
        <div className="notif-header d-flex justify-content-between align-items-center p-2">
          <h5 className="m-0">Notifications</h5>
          <button className="btn-close" onClick={onClose}></button>
        </div>

        <hr />

        <div className="notif-body">
          {(notifications?.length && notifications.length > 0) ? (
            notifications.map((n) => (
              <div
                key={n.notificationId}
                className="p-2 border-bottom"
                onClick={() =>
                  navigation("/Customerdetails", {
                    state: { userId: n.userId },
                  })
                }
              >
                <img
                  src={n.profilePath || default_avatar}
                  alt="Profile"
                  width="45"
                  height="45"
                  style={{
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginRight: "10px",
                  }}
                />
                <label>{n.name} {n.message}</label>
              </div>
            ))
          ) : (
            <div className="text-center mt-4">
              <div style={{ fontSize: "50px" }}>
                <i className="bi bi-bell-fill"></i>
              </div>
              <p className="mt-2">You have no notifications so far</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Notification;